import type { HereAndNowTab } from "@lib/logic";

import { HaN } from "./shell/HaN";

export const HereAndNowRevamp = ({ tab }: { tab: HereAndNowTab }) => {
  return (
    <HaN.Page tab={tab}>
      <HaN.DebugPanel />
    </HaN.Page>
  );
};
